import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Form,
  Row,
  Spin,
  Tag,
  Typography,
} from "antd";

import { SettingOutlined } from "@ant-design/icons";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import "../../../../assets/styles/InterbankPlacement.css";
import {
  AccountFacility,
  handleInterBankContractActionButtons,
} from "../../../../components/facilities/TreasuryFacility";
import MainLayout from "../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../contractbooking.config";
import Transactions from "./tabs/Transactions";

const { Panel } = Collapse;
const { Text, Title } = Typography;

const ViewInterBankContract = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state } = useLocation();
  console.log(state);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [showInterestChecked, setShowInterestChecked] = useState(false);
  const [menuProps, setMenuProps] = useState({ items: [] });
  const [InterBankPlacementDetails, setInterBankPlacementDetails] = useState(
    []
  );
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [transactionsList, setTransactionsList] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [useForm] = Form.useForm();
  const [counterPartyInfo, setCounterPartyInfo] = useState({});

  const maturityDate =
    BOM.DateTime(InterBankPlacementDetails.maturityDate, "only-date") ?? "--";

  // Optional: define known fields you want to tag as tags (for colored labels or badges in UI)
  const knownTagFields = [
    "kycStatus",
    "status",
    "sendDealConfirmation",
    "productCategory",
    "productType",
    "currency",
  ];

  const contractBookingData = {};

  const tabList = [
    {
      key: "transactions",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Transactions</span>
        </div>
      ),
    },
    // {
    //   key: "charges",
    //   label: "Charges",
    //   disabled: !BOM.HasPermission("READ_SAVINGSACCOUNTCHARGE"),
    // },
  ];

  useEffect(() => {
    getInterbankPlaementById(state);
    getTransactionDetailById(state);
    getClientCounterParty(state);
  }, []);

  const getInterbankPlaementById = (params) => {
    const url = `${apiConfig.InterbankContract}/${params.id}`;

    let body = {
      session,
    };
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        console.log(objDetail);
        setInterBankPlacementDetails(objDetail);
        // getInterBankProductDetails(objDetail?.product?.id);

        setMenuProps({
          items: handleInterBankContractActionButtons(objDetail),
          onClick: (e) => {
            console.log(e);

            const item = handleInterBankContractActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "activate":
                  return activateContract();
                case "disable":
                  return disableContract();
                case "close deal":
                  return closeContract();
                // case "reject deal":
                // return rejectContract();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      actionLabel: item.label,
                      contractObj: objDetail,
                    },
                  });
              }
            }
          },
        });
        setIsLoading(false);
      }
    });
  };

  const getTransactionDetailById = (params) => {
    const url = `${apiConfig.InterbankContract}/${params.id}/transactions`;

    let body = {
      session,
    };
    setIsLoading(true);

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setAccountDetails(objDetail);
        console.log(objDetail);

        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.dateOf
              ? BOM.DateTime(element?.dateOf, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value?.replace("actionType.", "")
              : "-",
            transactionRef: element?.refNo ? element?.refNo : "-",
            amount:
              element?.amount && element?.amount !== 0
                ? Number(element?.amount).toLocaleString()
                : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
            transactionTypeDetail: element.transactionType,
          });
        });

        // setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        setIsLoading(false);
      }
    });
  };

  const getClientCounterParty = (params) => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Counterparty}/${params.customerId}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        // setCounterPartyExists(false);
        // setCounterPartyDetails(null);
        // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);
        // setCounterPartyExists(true);
        const objList = res;
        setCounterPartyInfo(objList);
      }
    });
  };

  const transformedData = [
    {
      section: "Contract Information",
      items: [
        {
          name: "Product Code",
          value: InterBankPlacementDetails?.product?.productCode ?? "-",
        },
        {
          name: "Product Name",
          value: InterBankPlacementDetails?.product?.productName ?? "-",
          isTag: true,
        },
        {
          name: "Product Currency",
          value: InterBankPlacementDetails?.currency?.code ?? "-",
          isTag: true,
        },
        {
          name: "Custodian",
          value: InterBankPlacementDetails?.custodian?.name ?? "-",
          isTag: true,
        },
        {
          name: "Placement Type",
          value: InterBankPlacementDetails?.placementType?.text ?? "--",
          isTag: true,
        },
        {
          name: "Collateral Type",
          value: InterBankPlacementDetails?.collateralType?.name ?? "--",
          isTag: true,
        },
        {
          name: "Collateral Volume",
          value:
            InterBankPlacementDetails?.collateralVolume?.toLocaleString() ??
            "-",
          type: "text",
        },
        {
          name: "Collateral Number",
          value: InterBankPlacementDetails?.collateralNumber ?? "-",
          type: "text",
        },
        {
          name: "Collateral Value",
          value: InterBankPlacementDetails?.collateralValue
            ? `${InterBankPlacementDetails?.collateralCurrency} ${Number(
                InterBankPlacementDetails?.collateralValue
              )?.toLocaleString()}`
            : "--",
          type: "text",
        },
        {
          name: "Collateral Maturity Date",
          value: InterBankPlacementDetails?.collateralMaturityDate
            ? BOM.DateTime(InterBankPlacementDetails?.collateralMaturityDate)
            : "-",
          type: "text",
        },
        {
          name: "Collateral Reference",
          value: InterBankPlacementDetails?.collateralIdentifier ?? "-",
          type: "text",
        },
        {
          name: "Start Date",
          value: InterBankPlacementDetails.submittedOnDate
            ? BOM.DateTime(
                InterBankPlacementDetails.submittedOnDate,
                "only-date"
              )
            : "--",
          type: "text",
        },
        {
          name: "Approval Date",
          value: InterBankPlacementDetails.approvedOnDate
            ? BOM.DateTime(
                InterBankPlacementDetails.approvedOnDate,
                "only-date"
              )
            : "--",
          type: "text",
        },
        {
          name: "Disbursement Date",
          value: InterBankPlacementDetails.disbursementDate
            ? BOM.DateTime(
                InterBankPlacementDetails.disbursementDate,
                "only-date"
              )
            : "--",
          type: "text",
        },
        {
          name: "Maturity Date",
          value: InterBankPlacementDetails.maturityDate
            ? BOM.DateTime(InterBankPlacementDetails.maturityDate, "only-date")
            : "--",
          type: "text",
        },
      ],
    },

    {
      section: "Term Information",
      items: [
        {
          name: "Interest Rate",
          value: `${InterBankPlacementDetails.interestRate} %` ?? "--",
          type: "text",
          isTag: true,
        },
        {
          name: "Interest Type",
          value:
            InterBankPlacementDetails?.interestRateType?.code.replace(
              "interestType.",
              ""
            ) ?? "--",
          isTag: true,
        },
        {
          name: "Tenor",
          value: `${InterBankPlacementDetails?.tenor} Days` ?? "-",
          isTag: true,
        },

        {
          name: "Amount Placed",
          value: InterBankPlacementDetails?.amount?.toLocaleString() || "--",
          isTag: true,
        },
        {
          name: "Maturity Value",
          value:
            InterBankPlacementDetails?.maturityValue?.toLocaleString() || "--",
          isTag: true,
        },

        {
          isInlineGroup: true,
          group: [
            {
              name: "Placement Fee",
              isTagGroup: true,
              fields: [
                {
                  value: InterBankPlacementDetails.allowRollover ?? "-",
                  isTag: true,
                },
                {
                  value:
                    InterBankPlacementDetails.placementFee !== undefined
                      ? InterBankPlacementDetails.placementFee
                        ? "With Penalty"
                        : "Without Penalty"
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Withholding Tax",
              isTagGroup: true,
              fields: [
                {
                  value: InterBankPlacementDetails.autoRollover ?? "-",
                  isTag: true,
                },
                {
                  value:
                    InterBankPlacementDetails.placementFee !== undefined
                      ? InterBankPlacementDetails.placementFee
                        ? "With Penalty"
                        : "Without Penalty"
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      section: "Counterparty Information",
      items: [
        // {
        //   name: "Branch Code",
        //   value: InterBankPlacementDetails.bankCode|| "--",
        //   isTag: true,
        // },
        {
          name: "Bank Name",
          value: InterBankPlacementDetails?.counterparty?.bankName || "--",
          isTag: true,
        },
        {
          isInlineGroup: true,
          group: [
            {
              name: "Deal Confirmation",
              isTagGroup: true,
              fields: [
                {
                  value: InterBankPlacementDetails.dealConfirmation ?? "-",
                  isTag: true,
                },
                {
                  value:
                    InterBankPlacementDetails.dealConfirmation &&
                    counterPartyInfo.contactEmail !== undefined
                      ? counterPartyInfo.contactEmail
                      : "-",
                  isTag: true,
                },
              ],
            },
          ],
        },
      ],
    },
  ];

  const renderTag = (value) => {
    if (value === true) {
      return (
        <Tag
          style={{
            backgroundColor: "#ECFDF3",
            border: "1px solid #ABEFC6",
            borderRadius: "16px",
            padding: "2px 12px",
          }}
        >
          <Text
            style={{
              color: "#067647",
              fontWeight: 600,
            }}
          >
            Yes
          </Text>
        </Tag>
      );
    }

    if (value === false) {
      return (
        <Tag
          style={{
            backgroundColor: "#F9FAFB",
            border: "1px solid #EAECF0",
            borderRadius: "16px",
            padding: "2px 12px",
            textTransform: "capitalize",
          }}
        >
          <Text
            style={{
              color: "#344054",
              fontWeight: 600,
            }}
          >
            No
          </Text>
        </Tag>
      );
    }

    if (
      value === "-" ||
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return (
        <Text style={{ fontWeight: 500, color: "#6b7280" }}>
          {value || "-"}
        </Text>
      );
    }

    // Default tag for select fields
    return (
      <Tag
        style={{
          backgroundColor: "#FDF4FF",
          border: "1px solid #F6D0FE",
          borderRadius: "16px",
          padding: "2px 12px",
        }}
      >
        <Text
          style={{
            textTransform: "capitalize",
            color: "#9F1AB1",
            fontWeight: 600,
          }}
        >
          {value}
        </Text>
      </Tag>
    );
  };

  const renderRow = (item, index, section) => {
    const isLastItem =
      index === (contractBookingData[section]?.items?.length || 0) - 1;

    if (item.isInlineGroup && Array.isArray(item.group)) {
      return (
        <div
          key={`inline-group-${section}-${index}`}
          style={{
            display: "flex",
            borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
          }}
        >
          {item.group.map((fieldGroup, groupIndex) => (
            <>
              <div
                key={`group-${groupIndex}`}
                style={{
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#f9f9f9",
                  fontWeight: "500",
                  borderRight: "1px solid #f0f0f0",
                }}
              >
                {fieldGroup.name}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: 1,
                  padding: "16px 24px",
                  width: "50%",
                  backgroundColor: "#fff",
                }}
              >
                {fieldGroup.fields.map((subField) => (
                  <div
                    key={subField.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {subField.isTag ? (
                      renderTag(subField.value)
                    ) : (
                      <span>{subField.value}</span>
                    )}
                  </div>
                ))}
              </div>
            </>
          ))}
        </div>
      );
    }

    return (
      <div
        key={item.key || item.name}
        style={{
          display: "flex",
          borderBottom: isLastItem ? "none" : "1px solid #f0f0f0",
        }}
      >
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#f9f9f9",
            fontWeight: "500",
            borderRight: "1px solid #f0f0f0",
          }}
        >
          {item.name}
        </div>
        <div
          style={{
            padding: "16px 24px",
            width: "50%",
            backgroundColor: "#fff",
          }}
        >
          {item.isTag ? (
            renderTag(item.value)
          ) : (
            <Text style={{ textTransform: "capitalize", fontWeight: 600 }}>
              {item.value}
            </Text>
          )}
        </div>
      </div>
    );
  };

  function activateContract() {
    setIsLoading(true);
    const params = {
      command: "activate",
    };

    const url = `${apiConfig.InterbankContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Activated succesfully");
        //STOP LOAD

        getInterbankPlaementById(state);

        setIsLoading(false);
      }
    });
  }
  function disableContract() {
    setIsLoading(true);
    const params = {
      command: "disable",
    };
    const url = `${apiConfig.InterbankContract}/${state}/modify-status?`;

    const body = {
      method: "POST",
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Product Disabled succesfully");
        //STOP LOAD
        getInterbankPlaementById(state);

        setIsLoading(false);
      }
    });
  }
  function closeContract() {
    console.log("Closing..");

    setIsLoading(true);
    // const params = {
    //   command: "close",
    // };
    const url = `${apiConfig.InterbankContract}/${state.id}/close`;

    const body = {
      method: "POST",
      session,
      // params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Contract Closed succesfully");
        //STOP LOAD
        getInterbankPlaementById(state);

        setIsLoading(false);
      }
    });
  }

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        state={state}
        userData={userData}
        showInterestChecked={showInterestChecked}
        setShowInterestChecked={setShowInterestChecked}
      />
    ),
    // charges: <div>Charges</div>,
  };

  return (
    <MainLayout pageItems={staticConfig.viewcontractbookingInterbankPlacement}>
      <TopContent
        pageTitle={labelConfig.manageContractBookingInterbankplacement}
        createPageTitle={labelConfig.viewContractBookingInterbankplacement}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <div layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              {/* <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 12,
                    paddingBottom: 12,
                    // paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 24, backgroundColor: "#EAE7EC" }}
                >
                  <Row>
                    <Col span={12}>
                      <Statistic
                        title={"Customer Name"}
                        value={
                          InterBankPlacementDetails?.client?.displayName ??
                          "-- -- -- -- --"
                        }
                        valueStyle={{
                          fontSize: "16px",
                        }}
                      />

                      <Statistic
                        title={"Contract Ref. ID"}
                        value={
                          InterBankPlacementDetails?.contractReferenceId ??
                          "-- -- -- -- --"
                        }
                        valueStyle={{
                          fontSize: "16px",
                        }}
                      />
                    </Col>
                    <Col span={12}>
                      {InterBankPlacementDetails?.status?.text
                        ? handleFlgStatus(
                            InterBankPlacementDetails?.status.text,
                            {
                              fontSize: 16,
                            },
                            false
                          )
                        : "-"}
                    </Col>
                  </Row>
                </Card>
              </Col> */}
            </Row>

            <AccountFacility
              status={InterBankPlacementDetails?.status?.text}
              name={InterBankPlacementDetails?.client?.displayName}
              id={InterBankPlacementDetails?.contractReferenceId}
              amount={InterBankPlacementDetails?.amount}
              interest={InterBankPlacementDetails?.maturityValue}
              currencyCode={InterBankPlacementDetails?.currency?.code}
              interestPerAnnum={InterBankPlacementDetails?.interestRate}
              maturityDate={maturityDate}
            />

            <Row
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 20,
              }}
            >
              {transformedData?.map((section, index) => (
                <Col style={{}}>
                  <Collapse
                    className="custom-collapse"
                    // expandIconPosition="start"
                    expandIcon={<ChevronDown color="red" />}
                    style={{
                      backgroundColor: "transparent",
                      padding: 0,
                    }}
                  >
                    <Panel
                      key={index + 1}
                      header={
                        <span
                          style={{
                            fontSize: "16px",
                            fontWeight: 500,
                            textTransform: "capitalize",
                          }}
                        >
                          {section.section}
                        </span>
                      }
                      style={{
                        borderRadius: "8px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          border: "1px solid #f0f0f0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        {section?.items?.map((item, itemIndex) =>
                          renderRow(item, itemIndex, index)
                        )}
                      </div>
                    </Panel>
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        </Card>
        <Card
          className="custom-transaction-tab"
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            // boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewInterBankContract);
